var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.shouldShowKeyboard ? _c('section', {
    staticClass: "questionSection"
  }, [_vm.currentRound.dynamicContent ? _c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.dynamicContent
    }
  }) : _vm._e()], 1) : _vm._e(), !_vm.shouldShowKeyboard ? _c('section', {
    attrs: {
      "id": "dragAndDropSection"
    }
  }, [_c('div', {
    attrs: {
      "id": "dragAndDropSubSection"
    }
  }, [_vm.currentRound.draggableItems && _vm.currentRound.draggableItems.length ? _c('div', {
    staticClass: "draggableArea"
  }, [_c('div', {
    staticClass: "draggableBankArea focusable",
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleDragContainerEnterEvent();
      }
    }
  }, _vm._l(_vm.currentRound.draggableItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "startingPoint",
      style: {
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
      },
      attrs: {
        "id": ("startingPoint-" + (item.id))
      }
    }, [_c('div', {
      class: ['draggableItem', 'focusable', {
        'element-selected': _vm.selectedElement && _vm.selectedElement.id === ("draggable-" + (item.id))
      }],
      style: {
        margin: ((_vm.dragTileMargin) + " 0px")
      },
      attrs: {
        "id": ("draggable-" + (item.id)),
        "role": "button",
        "data-id": ("" + (item.id)),
        "tabindex": _vm.isGuessed(item) ? -1 : 10
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnDraggableItemEnterEvent(item.id, true);
        }
      }
    }, [_c('div', {
      staticClass: "dragAndDropContent",
      style: {
        background: _vm.getDragContentBackground(item)
      }
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])])]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "droppableArea"
  }, [_vm.currentRound.table ? _c('table', {
    attrs: {
      "borderCornerSize": '0px'
    }
  }, [_c('tbody', [!!_vm.currentRound.table.labelHtml ? _c('tr', [_c('th', {
    attrs: {
      "colspan": "2",
      "id": "header"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.table.labelHtml
    }
  })], 1)]) : _vm._e(), _c('tr', _vm._l(_vm.currentRound.table.headers, function (header) {
    return _c('td', {
      key: header.label,
      staticClass: "columnName"
    }, [_vm._v("\n                    " + _vm._s(header.label) + "\n                  ")]);
  }), 0), _vm._l(_vm.currentRound.table.rows, function (row, idx) {
    return _c('tr', {
      key: idx,
      staticClass: "draggableRows"
    }, _vm._l(row.values, function (value) {
      return _c('td', {
        key: value.value,
        staticClass: "tableData"
      }, [!value.correct ? _c('div', [_vm._v(_vm._s(value.value))]) : _vm._e(), value.correct ? _c('div', {
        class: ['droppableItem', 'focusable', _vm.getDroppableItemClass(), {
          'selectable-answer': !!_vm.selectedElement
        }],
        style: {
          backgroundColor: ((_vm.getDroppableBackground(value)) + " !important")
        },
        attrs: {
          "id": ("dropArea-" + (value.value)),
          "aria-label": _vm.getDropItemAriaLabel(value, row),
          "tabindex": _vm.isGuessedCorrectly(value) ? -1 : 10
        },
        on: {
          "keyup": function ($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.handleOnDroppableItemEnterEvent(("dropArea-" + (value.value)), true);
          }
        }
      }, [_vm.isGuessedCorrectly(value) && _vm.isSubmitted ? _c('CorrectIcon', {
        staticClass: "feedbackIcon",
        attrs: {
          "height": "36px",
          "width": "36px"
        }
      }) : _vm._e(), _vm.isGuessedIncorrectly(value) ? _c('WrongIcon', {
        staticClass: "feedbackIcon",
        attrs: {
          "height": "36px",
          "width": "36px"
        }
      }) : _vm._e(), _vm.showCorrectAnswers && !_vm.isGuessedCorrectly(value) && !_vm.isSubmitted ? _c('div', {
        staticClass: "dragAndDropContent correctAnswerContent"
      }, [_vm._v("\n                        " + _vm._s(value.value) + "\n                      ")]) : _vm._e()], 1) : _vm._e()]);
    }), 0);
  })], 2)]) : _vm._e()])])]) : _vm._e(), _vm.shouldShowKeyboard ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "element": "div",
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText && _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e()])], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }